(() => {
  const P = 'JRMVariantGalleryData-';
  const C = 'JRMCommonGalleryData-';
  const K = '__JRMGalleryControlsV8';
  const LOADED = '__JRMGalleryControlsV8Loaded';
  const LEGACY_KEYS = [
    '__JRMGalleryControlsV2',
    '__JRMGalleryControlsV3',
    '__JRMGalleryControlsV4',
    '__JRMGalleryControlsV5',
    '__JRMGalleryControlsV6',
    '__JRMGalleryControlsV7',
    K
  ];
  const INITIAL_COMMON = 4;
  const MORE = 'View more product photos';
  const LESS = 'Show fewer product photos';
  const HOST_CLASS = 'jrm-gallery-controls-host';
  const STYLE_ID = 'jrm-gallery-controls-style';

  if (window[LOADED]) return;
  window[LOADED] = true;

  const mid = value => String(value ?? '').split('/').pop();
  const path = value => {
    if (!value) return '';
    try { return new URL(value, location.origin).pathname; }
    catch { return String(value).split('?')[0]; }
  };
  const urlVariant = () => {
    try { return new URL(location.href).searchParams.get('variant'); }
    catch { return null; }
  };

  function abortInlineGalleryControllers() {
    const controllers = window.JRMVariantGalleryControllers;
    if (!controllers || typeof controllers !== 'object') return;

    Object.values(controllers).forEach(controller => controller?.abort?.());
    window.JRMVariantGalleryControllers = {};
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      hdt-product-media.${HOST_CLASS} {
        position: relative;
        padding-bottom: 4.6rem;
      }
      hdt-product-media.${HOST_CLASS} > .jrm-gallery-view-controls {
        position: absolute;
        margin-top: 0;
        inset-inline: 0;
        bottom: 0;
        min-height: 3.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        z-index: 20;
        pointer-events: auto;
      }
      hdt-product-media.${HOST_CLASS} > .jrm-gallery-view-controls[hidden] {
        display: none !important;
      }
      .jrm-gallery-view-controls__button {
        appearance: none;
        background: none;
        border: 0;
        color: currentColor;
        cursor: pointer;
        font: inherit;
        padding: 4px 0;
        position: relative;
        text-decoration: underline;
        text-underline-offset: 3px;
        z-index: 1;
        pointer-events: auto;
      }
    `;
    document.head.append(style);
  }

  function make(media) {
    const section = media.closest('.shopify-section') || document;
    const owner = media.closest('.hdt-product-media-wrapps') || section;
    const dataRoot = owner.querySelector(`script[id^="${P}"]`) ||
      section.querySelector(`script[id^="${P}"]`);
    const commonRoot = owner.querySelector(`script[id^="${C}"]`);
    let data = {};
    if (dataRoot) {
      try { data = JSON.parse(dataRoot.textContent || '{}'); }
      catch { return null; }
    }
    let explicitCommonIds = [];
    if (commonRoot) {
      try { explicitCommonIds = JSON.parse(commonRoot.textContent || '[]'); }
      catch { explicitCommonIds = []; }
    }
    if (!Array.isArray(explicitCommonIds)) explicitCommonIds = [];

    ensureStyle();

    const mains = () => [...media.querySelectorAll('.hdt-product-media__main [data-media-id]')];
    const thumbs = () => [...media.querySelectorAll('hdt-slider-thumb [data-media-id]')];
    const reinit = () => {
      media.sliderMain?.reInit?.();
      media.sliderThumb?.reInit?.();
    };
    const goto = item => item && requestAnimationFrame(() => media.sliderMain?.goToTarget?.(item));
    const current = mainItems => {
      const visible = mainItems.filter(item => !item.hidden);
      return visible.find(item =>
        item.matches('[aria-current="true"],[selected]') ||
        item.classList.contains('is-selected') ||
        item.classList.contains('hdt-slider__slide--selected')
      ) || visible[0] || null;
    };

    const originalMainOrder = mains().map(item => mid(item.dataset.mediaId)).filter(Boolean);
    if (!originalMainOrder.length) return null;

    function mediaLookup(mainItems) {
      const byId = new Map();
      const byPath = new Map();

      mainItems.forEach(item => {
        const id = mid(item.dataset.mediaId);
        if (id) byId.set(id, id);

        const img = item.querySelector('img') ||
          item.querySelector('template[data-jrm-media-template]')?.content.querySelector('img');
        [img?.currentSrc, img?.src, img?.getAttribute('src')].forEach(src => {
          const p = path(src);
          if (p && id) byPath.set(p, id);
        });
      });

      return { byId, byPath };
    }

    function variantIds(variantId, lookup) {
      const entries = data[String(variantId)] || [];
      if (!Array.isArray(entries) || !entries.length) return [];

      const { byId, byPath } = lookup;
      const out = [];
      const seen = new Set();

      entries.forEach(entry => {
        const entryId = mid(entry?.id);
        const id = (entryId && byId.get(entryId)) || byPath.get(path(entry?.src)) || '';
        if (id && !seen.has(id)) {
          seen.add(id);
          out.push(id);
        }
      });

      return out;
    }

    function nativeIds(variantId, variant, mainItems) {
      if (!variantId) return [];
      const available = new Set(originalMainOrder);
      const out = [];
      const preferred = [variant?.mdid, variant?.featured_media?.id, variant?.featured_image?.id];
      preferred.forEach(value => {
        const id = mid(value);
        if (id && available.has(id) && !out.includes(id)) out.push(id);
      });
      mainItems.forEach(item => {
        const ids = String(item.dataset.variantsId || '').split(';').map(id => id.trim());
        const id = mid(item.dataset.mediaId);
        if (ids.includes(String(variantId)) && id && !out.includes(id)) out.push(id);
      });
      return out;
    }

    function commonIds(mainItems, thumbItems, lookup) {
      const available = new Set(originalMainOrder);
      if (media.hasAttribute('data-jrm-explicit-common')) {
        const marked = explicitCommonIds.length
          ? explicitCommonIds.map(mid)
          : thumbItems.filter(item => item.dataset.jrmCommon === 'true')
            .map(item => mid(item.dataset.mediaId));
        return [...new Set(marked.filter(id => available.has(id)))];
      }

      const usedByVariants = new Set();
      Object.keys(data).forEach(variantId => {
        variantIds(variantId, lookup).forEach(id => usedByVariants.add(id));
      });
      mainItems.forEach(item => {
        if (item.dataset.variantsId) usedByVariants.add(mid(item.dataset.mediaId));
      });
      return originalMainOrder.filter(id => !usedByVariants.has(id));
    }

    function materializeItem(item, { priority = false } = {}) {
      if (!item || item.dataset.jrmDeferred !== 'true') return;

      const template = item.querySelector(
        'template[data-jrm-media-template], template[data-jrm-thumb-template]'
      );

      if (!template) {
        item.removeAttribute('data-jrm-deferred');
        return;
      }

      const fragment = template.content.cloneNode(true);
      if (priority) {
        const img = fragment.querySelector?.('img');
        if (img) {
          img.setAttribute('loading', 'eager');
          img.setAttribute('fetchpriority', 'high');
          try { img.fetchPriority = 'high'; } catch {}
        }
      }

      template.replaceWith(fragment);
      item.removeAttribute('data-jrm-deferred');
    }

    function hydrateThumb(item) {
      if (!item || item.dataset.jrmDeferred !== 'true') return;

      const img = item.querySelector('img[data-jrm-src]');
      if (!img) {
        materializeItem(item);
        return;
      }

      const src = img.dataset.jrmSrc;
      const srcset = img.dataset.jrmSrcset;

      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);

      img.removeAttribute('data-jrm-src');
      img.removeAttribute('data-jrm-srcset');
      item.removeAttribute('data-jrm-deferred');
    }

    function materializeIds(ids, mainItems, thumbItems, { priorityFirst = false } = {}) {
      const mainMap = new Map(mainItems.map(item => [mid(item.dataset.mediaId), item]));
      const thumbMap = new Map(thumbItems.map(item => [mid(item.dataset.mediaId), item]));

      ids.forEach((id, index) => {
        materializeItem(mainMap.get(id), { priority: priorityFirst && index === 0 });
        hydrateThumb(thumbMap.get(id));
      });
    }

    function setControlVisible(visible) {
      wrap.hidden = !visible;
      media.classList.toggle(HOST_CLASS, visible);
    }

    const wrap = document.createElement('div');
    wrap.className = 'jrm-gallery-view-controls';
    wrap.hidden = true;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jrm-gallery-view-controls__button';
    btn.textContent = MORE;
    btn.setAttribute('aria-expanded', 'false');
    if (media.sliderMain?.id) btn.setAttribute('aria-controls', media.sliderMain.id);
    wrap.append(btn);
    media.append(wrap);

    const state = {
      variantId: media.closest('#hdt-quick-view-modal')
        ? (media.dataset.jrmInitialVariantId || null)
        : (media.dataset.jrmInitialVariantId || urlVariant() || null),
      variant: null,
      expandedCommon: false
    };

    function render({ jumpToVariant = false } = {}) {
      const mainItems = mains();
      const thumbItems = thumbs();
      const lookup = mediaLookup(mainItems);
      const common = commonIds(mainItems, thumbItems, lookup);

      let selected = [];
      if (state.variantId) {
        selected = variantIds(state.variantId, lookup);
        if (!selected.length) selected = nativeIds(state.variantId, state.variant, mainItems);
      }
      if (!selected.length) {
        const featured = mid(media.dataset.jrmFeaturedMediaId) || originalMainOrder[0];
        selected = [lookup.byId.get(featured) || originalMainOrder[0]];
      }

      const selectedSet = new Set(selected);
      const additionalCommon = common.filter(id => !selectedSet.has(id));

      const visibleCommon = state.expandedCommon
        ? additionalCommon
        : additionalCommon.slice(0, INITIAL_COMMON);
      const wanted = [...selected, ...visibleCommon];

      materializeIds(wanted, mainItems, thumbItems, { priorityFirst: true });

      const allowed = new Set(wanted);
      const keep = current(mainItems);

      mainItems.forEach(item => {
        item.hidden = !allowed.has(mid(item.dataset.mediaId));
      });
      thumbItems.forEach(item => {
        item.hidden = !allowed.has(mid(item.dataset.mediaId));
      });
      reinit();

      let target = null;
      if (jumpToVariant && selected.length) {
        target = mainItems.find(item => mid(item.dataset.mediaId) === selected[0]);
      } else if (keep && !keep.hidden) {
        target = keep;
      } else if (selected.length) {
        target = mainItems.find(item => mid(item.dataset.mediaId) === selected[0]);
      } else if (visibleCommon.length) {
        target = mainItems.find(item => mid(item.dataset.mediaId) === visibleCommon[0]);
      }
      goto(target);

      setControlVisible(additionalCommon.length > INITIAL_COMMON);
      btn.textContent = state.expandedCommon ? LESS : MORE;
      btn.setAttribute('aria-expanded', String(state.expandedCommon));
    }

    btn.addEventListener('click', () => {
      state.expandedCommon = !state.expandedCommon;
      render();
    });

    const onVariant = event => {
      if (event.target !== media.form) return;
      const variant = event.detail?.variant;
      state.variantId = variant?.id ? String(variant.id) : null;
      state.variant = variant || null;
      requestAnimationFrame(() => render({ jumpToVariant: true }));
    };

    let resizeTimer = 0;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => render(), 120);
    };

    document.addEventListener('variant:change', onVariant);
    window.addEventListener('resize', onResize, { passive: true });
    requestAnimationFrame(() => render({ jumpToVariant: true }));

    return {
      destroy() {
        document.removeEventListener('variant:change', onVariant);
        window.removeEventListener('resize', onResize);
        window.clearTimeout(resizeTimer);
        media.classList.remove(HOST_CLASS);
        wrap.remove();
      }
    };
  }

  const controllers = new Map();
  const ready = window.customElements?.whenDefined
    ? customElements.whenDefined('hdt-product-media')
    : Promise.resolve();

  function destroyWithin(root) {
    controllers.forEach((controller, media) => {
      if (root.contains(media) || !media.isConnected) {
        controller.destroy();
        controllers.delete(media);
      }
    });
    window[K] = [...controllers.values()];
  }

  function init(root = document) {
    destroyWithin(root);
    const mediaRoots = [
      ...(root.matches?.('hdt-product-media[data-jrm-unified-gallery]') ? [root] : []),
      ...root.querySelectorAll('hdt-product-media[data-jrm-unified-gallery]')
    ];
    mediaRoots.forEach(media => {
      const controller = make(media);
      if (controller) controllers.set(media, controller);
    });
    window[K] = [...controllers.values()];
  }

  abortInlineGalleryControllers();
  LEGACY_KEYS.filter(key => key !== K).forEach(key => {
    window[key]?.forEach?.(controller => controller.destroy());
    delete window[key];
  });
  window.setTimeout(abortInlineGalleryControllers, 0);
  window.setTimeout(abortInlineGalleryControllers, 250);

  ready.then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }
  });
  document.addEventListener('shopify:section:load', event => {
    ready.then(() => requestAnimationFrame(() => init(event.target)));
  });
  document.addEventListener('shopify:section:unload', event => destroyWithin(event.target));
  document.addEventListener('dialog:opening', event => {
    if (event.target.id === 'hdt-quick-view-modal') ready.then(() => init(event.target));
  }, true);
  document.addEventListener('dialog:closing', event => {
    if (event.target.id === 'hdt-quick-view-modal') destroyWithin(event.target);
  }, true);
})();

